import { Typography } from "@mui/material";

export default function TableListTotal({ totalResults, displayedResults }: { totalResults: number; displayedResults: number}) {
  return (
    <Typography variant="caption" color="text.muted" component="div">
    {totalResults > displayedResults
      ? `${displayedResults} of ${totalResults} results`
      : `${displayedResults} results`}
  </Typography>
  );
}
